import { render, staticRenderFns } from "./AgencyMiddle.vue?vue&type=template&id=3801c906&scoped=true"
import script from "./AgencyMiddle.vue?vue&type=script&lang=js"
export * from "./AgencyMiddle.vue?vue&type=script&lang=js"
import style0 from "./AgencyMiddle.vue?vue&type=style&index=0&id=3801c906&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3801c906",
  null
  
)

export default component.exports